import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '../utils/apiClient';
import { useToast } from '../context/ToastContext';
import { FiPlus } from 'react-icons/fi';
import ProductTable from '../components/admin/ProductTable';
import '../styles/Admin.css';

const AdminProducts = () => {
    const toast = useToast();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const token = sessionStorage.getItem('adminToken');
        if (!token) {
            navigate('/admin/login');
            return;
        }
        fetchProducts();
    }, [navigate]);

    const fetchProducts = async () => {
        try {
            const response = await apiClient.get(`/products?limit=1000`);
            setProducts(response.data.products || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching products:', error);
            setLoading(false);
        }
    };

    const handleDeleteProduct = async (id) => {
        if (window.confirm('Are you sure you want to delete this product?')) {
            try {
                const token = sessionStorage.getItem('adminToken');
                await apiClient.delete(`/products/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                fetchProducts(); // Refresh list
            } catch (error) {
                console.error('Error deleting product:', error);
                toast.error('Failed to delete product');
            }
        }
    };

    const handleDuplicateProduct = async (product) => {
        if (window.confirm(`Duplicate ${product.name}?`)) {
            toast.info('Duplicate functionality coming soon!');
        }
    };

    if (loading) return <div className="admin-container">Loading...</div>;

    return (
        <div className="admin-container">
            <div className="admin-header">
                <div className="header-left">
                    <h1>Products</h1>
                </div>
                <div className="admin-actions">
                    <Link to="/admin/add" className="add-btn">
                        <FiPlus /> Add New Product
                    </Link>
                </div>
            </div>

            <ProductTable
                products={products}
                onDelete={handleDeleteProduct}
                onDuplicate={handleDuplicateProduct}
            />
        </div>
    );
};

export default AdminProducts;
